<template>
  <div class="tip-field">
    <transition name="fade">
      <v-text-field
        v-if="hasTip"
        label="Tip"
        prefix="$"
        :class="['tip-amount mt-2', { large: _includes(['sm', 'xs'], $mq) }]"
        clearable
        type="number"
        :rules="[(v) => Number(v) >= 0 || 'Some tipper, *you* are!']"
        :value="tipValue"
        @input="updateTip"
        autofocus
        outlined
        @click:clear="removeTip"
        dense
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _includes from 'lodash/includes'

export default {
  name: 'CartTipField',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', ['getTipFromCart', 'hasTip']),
    tipValue() {
      return this.getTipFromCart / 100
    },
  },
  methods: {
    ...mapActions('cart', ['updateTip', 'removeTip']),
    _includes,
  },
}
</script>

<style>
.tip-amount.large {
  font-size: 24px;
}
</style>
